import { render, staticRenderFns } from "./MsotAddMain.vue?vue&type=template&id=0abd530b&scoped=true&"
import script from "./MsotAddMain.vue?vue&type=script&lang=js&"
export * from "./MsotAddMain.vue?vue&type=script&lang=js&"
import style0 from "./MsotAddMain.vue?vue&type=style&index=0&id=0abd530b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0abd530b",
  null
  
)

export default component.exports